import { render, staticRenderFns } from "./ConnectionDetails.vue?vue&type=template&id=d5643712&scoped=true"
import script from "./ConnectionDetails.vue?vue&type=script&lang=js"
export * from "./ConnectionDetails.vue?vue&type=script&lang=js"
import style0 from "./ConnectionDetails.vue?vue&type=style&index=0&id=d5643712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5643712",
  null
  
)

export default component.exports